import { axiosInstance } from '../utils/axiosinstance';

// Types for admin login
export interface AdminLoginRequest {
  email: string;
  password: string;
}

export interface AdminLoginResponse {
  success: boolean;
  message: string;
  data?: {
    token: string;
    admin: {
      id: string;
      email: string;
      name?: string;
    };
  };
  // Legacy support
  token?: string;
  admin?: {
    id: string;
    email: string;
    name?: string;
  };
}

export interface UserProfile {
  success: boolean;
  message?: string;
  data?: {
    role: string;
    admin: {
      id: string;
      email: string;
      name?: string;
      firstName?: string;
      lastName?: string;
    };
  };
  // Legacy support
  user?: {
    id: string;
    email: string;
    name: string;
    firstName?: string;
    lastName?: string;
    role?: string;
  };
}

// Admin API functions
export const adminApi = {
  login: async (credentials: AdminLoginRequest): Promise<AdminLoginResponse> => {
    const response = await axiosInstance.post('/api/v1/admin/login', credentials);
    return response.data;
  },
  
  getProfile: async (): Promise<UserProfile> => {
    const token = localStorage.getItem('adminToken');
  
    
    const response = await axiosInstance.get('/api/v1/auth/profile', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
  
    return response.data;
  },
  
  logout: () => {
    localStorage.removeItem('adminToken');
  },
};
